import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import user from './modules/user'
import accidentCase from './modules/accident-case'
import productionSafetyAccident from './modules/production-safety-accident'
import commonPlugin from './commonPlugin.js'
import farm from './modules/farm'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    app,
    user,
    accidentCase,
    productionSafetyAccident,
    farm
  },
  plugins: [commonPlugin]
})
